import React from 'react';
import { HeartPulseIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { ProductImage } from '../ProductImage';
import { BRAND, PRICE } from '../../data/salesContent';
export function HeroSection() {
  return <header className="relative overflow-hidden border-b border-line bg-canvas px-5 pb-20 pt-10 md:pb-24 md:pt-14" data-id="element-134" data-mp="218rqrus6eusm">
      <div className="pointer-events-none absolute inset-0 opacity-[0.35]" style={{
      backgroundImage: 'linear-gradient(rgb(var(--c-line)) 1px, transparent 1px), linear-gradient(90deg, rgb(var(--c-line)) 1px, transparent 1px)',
      backgroundSize: '56px 56px',
      maskImage: 'linear-gradient(to bottom, black, transparent 85%)',
      WebkitMaskImage: 'linear-gradient(to bottom, black, transparent 85%)'
    }} aria-hidden="true" data-id="element-135" data-mp="1x8hiucktpub4" />
      <div className="relative mx-auto max-w-6xl" data-id="element-136" data-mp="19jonah845oh1">
        <p className="flex items-center justify-center gap-2 text-sm font-extrabold uppercase tracking-[0.25em] text-ink lg:justify-start" data-id="element-137" data-mp="19idhycz0s8nt">
          <HeartPulseIcon className="h-4 w-4 text-accent" aria-hidden="true" data-id="element-138" data-mp="31oe4p34zqx66" />
          {BRAND}
        </p>
        <div className="mt-10 grid items-center gap-12 lg:grid-cols-[1.05fr_1fr]" data-id="element-139" data-mp="36fe4cg5hvtcd">
          <div className="text-center lg:text-left" data-id="element-140" data-mp="2snpqo8flkwta">
            <h1 className="text-4xl font-black uppercase leading-[1.05] tracking-tight text-ink md:text-6xl" data-id="element-141" data-mp="2sp0v8agva8lg">
              Dejá de preparar cada charla de salud <span className="text-accent" data-id="element-142" data-mp="3kevlqaggo4bp">desde cero.</span>
            </h1>
            <p className="mx-auto mt-6 max-w-xl text-lg leading-relaxed text-muted md:text-xl lg:mx-0" data-id="element-143" data-mp="3kcswvtr1oh8k">
              Todo lo que necesitás para organizar, adaptar y presentar actividades de educación para la salud en un solo sistema.
            </p>

            <div className="mt-8 rounded-2xl border border-line bg-surface/90 p-5 text-left md:p-6" data-id="element-144" data-mp="3gbz4oo6kkg9v">
              <div className="flex flex-wrap items-end justify-between gap-4" data-id="element-145" data-mp="1zxza7sqhtiu0">
                <div data-id="element-146" data-mp="24y565l3sprhw">
                  <p className="text-xs font-bold uppercase tracking-[0.2em] text-muted" data-id="element-147" data-mp="24ymyw7r91nl2">Hoy por</p>
                  <p className="mt-1 text-4xl font-black tracking-tight text-ink tabular-nums md:text-5xl" data-id="element-148" data-mp="agbwsubsrjfp">{PRICE}</p>
                  <p className="mt-1 text-sm text-muted" data-id="element-149" data-mp="5jbxr3dd7gy3">Pago único · Acceso digital inmediato</p>
                </div>
                <ul className="space-y-1 text-sm font-medium text-ink sm:text-right" data-id="element-150" data-mp="ph7ti7625qk">
                  <li data-id="element-151" data-mp="3stjpuxoxkzjs">Acceso a los 5 volúmenes + 5 bonos</li>
                  <li className="text-muted" data-id="element-152" data-mp="3nxkugq56qh9v">100% digital · Acceso inmediato</li>
                </ul>
              </div>
              <div className="mt-5" data-id="element-153" data-mp="3ivvm5i9ckhph">
                <CtaButton data-id="element-154" data-mp="3dydmkih7zeu5">Quiero el sistema completo</CtaButton>
              </div>
            </div>

            <p className="mx-auto mt-6 max-w-xl text-sm leading-relaxed text-muted lg:mx-0" data-id="element-155" data-mp="39ws32ea6k2az">
              Pensado para profesionales, docentes, promotores y estudiantes avanzados del área de la salud.
            </p>
          </div>

          <ProductImage className="mx-auto w-full max-w-xl" data-id="element-156" data-mp="186gm2uabube2" />
        </div>
      </div>
    </header>;
}